var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.771262 14C0.555767 13.9996 0.350338 13.9087 0.205094 13.7495C0.0571725 13.5916 -0.0163304 13.378 0.00305578 13.1624L0.191266 11.0923L8.88583 2.39845L11.603 5.11557L2.91072 13.8087L0.841169 13.9969C0.817355 13.9992 0.79354 14 0.771262 14ZM12.1453 4.5723L9.42895 1.85518L11.0583 0.225366C11.2024 0.0810753 11.3979 0 11.6018 0C11.8057 0 12.0012 0.0810753 12.1453 0.225366L13.7747 1.85518C13.9189 1.99931 14 2.19489 14 2.39883C14 2.60278 13.9189 2.79836 13.7747 2.94249L12.1461 4.57153L12.1453 4.5723Z",
    fill: "#6165DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9af79e65e49d44311fd704674b5c839f.svg";
export { ForwardRef as ReactComponent };